import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { APIClient } from "../../helpers/api_helper";
import { toast } from "react-toastify";
import InputMask from "react-input-mask";
const apiClient = new APIClient();

const REDES_SOCIAIS = [
  { value: "instagram", label: "Instagram", prefix: "https://instagram.com/" },
  { value: "facebook", label: "Facebook", prefix: "https://facebook.com/" },
  { value: "x", label: "X (Twitter)", prefix: "https://x.com/" },
  { value: "tiktok", label: "TikTok", prefix: "https://tiktok.com/@" },
  { value: "youtube", label: "YouTube", prefix: "https://youtube.com/" },
];

const ModalParceiro = ({ isOpen, toggle, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    tel: "",
    redes_sociais: [{ rede: "", link: "" }],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRedeSocialChange = (index, field, value) => {
    setFormData((prev) => {
      const redes = [...prev.redes_sociais];
      redes[index] = { ...redes[index], [field]: value };
      return { ...prev, redes_sociais: redes };
    });
  };

  const adicionarRedeSocial = () => {
    setFormData((prev) => ({
      ...prev,
      redes_sociais: [...prev.redes_sociais, { rede: "", link: "" }],
    }));
  };

  const removerRedeSocial = (index) => {
    setFormData((prev) => ({
      ...prev,
      redes_sociais: prev.redes_sociais.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Remove redes sociais vazias e adiciona os prefixos
    const redes_sociais = formData.redes_sociais
      .filter((rede) => rede.rede && rede.link)
      .map((rede) => ({
        rede: rede.rede,
        link: rede.link.startsWith('http') ? rede.link : `${REDES_SOCIAIS.find(r => r.value === rede.rede)?.prefix}${rede.link}`
      }));

    try {
      const response = await apiClient.post("/parceiros", {
        ...formData,
        redes_sociais,
      });
      if (response?.sucesso) {
        const dados = response.dados;
        toast.success("Parceiro cadastrado com sucesso!");
        onSuccess();
        toggle();
        setFormData({
          nome: "",
          email: "",
          tel: "",
          redes_sociais: [{ rede: "", link: "" }],
        });
      } else {
        toast.error(response.mensagem || "Erro ao cadastrar parceiro");
      }
    } catch (error) {
      console.error("Erro completo:", error);
      toast.error("Erro ao cadastrar parceiro");
    }

    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <Form onSubmit={handleSubmit}>
        <ModalHeader toggle={toggle}>
          <span className="fw-semibold">Cadastrar Parceiro</span>
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="nome" className="fw-medium">
              Nome do Parceiro <span className="text-danger">*</span>
            </Label>
            <Input
              id="nome"
              name="nome"
              type="text"
              value={formData.nome}
              onChange={handleChange}
              placeholder="Nome do parceiro"
              required
              maxLength={255}
            />
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="email" className="fw-medium">
              Email <span className="text-danger">*</span>
            </Label>
            <Input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="exemplo@email.com"
              required
            />
          </FormGroup>

          <FormGroup className="mt-3">
            <Label for="tel" className="fw-medium">
              Telefone
            </Label>
            <InputMask
              mask="(99) 99999-9999"
              value={formData.tel}
              onChange={(e) => handleChange({
                target: {
                  name: 'tel',
                  value: e.target.value
                }
              })}
              placeholder="(11) 99999-9999"
            >
              {(inputProps) => (
                <Input type="text" className="form-control" {...inputProps} />
              )}
            </InputMask>
          </FormGroup>

          <div className="mt-4">
            <Label className="fw-medium">Redes Sociais</Label>
            {formData.redes_sociais.map((rede, index) => (
              <div key={index} className="row mt-2">
                <div className="col-md-4">
                  <FormGroup>
                    <Input
                      type="select"
                      value={rede.rede}
                      onChange={(e) =>
                        handleRedeSocialChange(index, "rede", e.target.value)
                      }
                    >
                      <option value="">Selecione uma rede</option>
                      {REDES_SOCIAIS.map((rs) => (
                        <option key={rs.value} value={rs.value}>
                          {rs.label}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </div>
                <div className="col-md-7">
                  <FormGroup>
                    <div className="input-group">
                      {rede.rede && (
                        <span className="input-group-text bg-light text-muted">
                          {REDES_SOCIAIS.find(r => r.value === rede.rede)?.prefix}
                        </span>
                      )}
                      <Input
                        type="text"
                        value={rede.link}
                        onChange={(e) =>
                          handleRedeSocialChange(index, "link", e.target.value)
                        }
                        placeholder="Seu perfil"
                        maxLength={100}
                      />
                    </div>
                  </FormGroup>
                </div>
                <div className="col-md-1">
                  <Button
                    type="button"
                    color="danger"
                    size="sm"
                    className="btn-icon"
                    onClick={() => removerRedeSocial(index)}
                  >
                    <i className="ri-delete-bin-line"></i>
                  </Button>
                </div>
              </div>
            ))}
            <Button
              type="button"
              color="light"
              size="sm"
              className="mt-2"
              onClick={adicionarRedeSocial}
            >
              <i className="ri-add-line me-1"></i>
              Adicionar Rede Social
            </Button>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            color="light"
            onClick={toggle}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            type="submit"
            color="info"
            className="ms-2"
            disabled={loading}
          >
            {loading && <Spinner size="sm" className="me-2" />}
            Cadastrar Parceiro
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ModalParceiro;
